import { Provider, Signal } from '@angular/core';

import { createProviderToken } from '@core/common-legacy';
import {
  ReportDashboardComponentViewData,
  ReportDashboardMetricOptions,
  VisualizationDataTypeUnion,
  VisualizationActionsAvailability,
} from '@core/reports-types';

const { provide: provideVisualizationData, inject: injectVisualizationData } = createProviderToken<
  Signal<VisualizationDataTypeUnion | undefined>
>('reportsProvideVisualizationData')();

const { provide: provideComponent, inject: injectComponent } =
  createProviderToken<Signal<ReportDashboardComponentViewData | undefined>>(
    'reportsProvideComponent',
  )();

const { provide: provideBaseComponent, inject: injectBaseComponent } = createProviderToken<
  Signal<ReportDashboardComponentViewData | undefined>
>('reportsProvideBaseComponent')();

const { provide: provideMetric, inject: injectMetric } =
  createProviderToken<Signal<ReportDashboardMetricOptions | undefined>>('reportsProvideMetric')();

const { provide: provideAvailableActions, inject: injectAvailableActions } = createProviderToken<
  Signal<VisualizationActionsAvailability>
>('reportsProvideAvailableActions')();

const { provide: provideVisualizationMeta, inject: injectVisualizationMeta } = createProviderToken<
  Signal<{ loaded: boolean; loading: boolean; failed: boolean; error?: any }>
>('reportsProvideVisualizationMeta')();

export const ReportsComponentFeatureProviders = {
  provideVisualizationData,
  provideComponent,
  provideMetric,
  provideAvailableActions,
  provideVisualizationMeta,
  provideBaseComponent,
};

export const ReportsComponentFeatureInjectors = {
  injectComponent,
  injectBaseComponent,
  injectMetric,
  injectAvailableActions,
  injectVisualizationData,
  injectVisualizationMeta,
};

export const reportsComponentFeatureProviderFactory = (providersFactories: {
  baseComponent?: () => Signal<ReportDashboardComponentViewData | undefined>;
  component?: () => Signal<ReportDashboardComponentViewData | undefined>;
  metric?: () => Signal<ReportDashboardMetricOptions | undefined>;
  availableActions?: () => Signal<VisualizationActionsAvailability>;
  visualizationData?: () => Signal<VisualizationDataTypeUnion | undefined>;
  visualizationMeta?: () => Signal<{
    loaded: boolean;
    loading: boolean;
    failed: boolean;
    error?: any;
  }>;
}): Provider[] =>
  [
    providersFactories.component && provideComponent({ useFactory: providersFactories.component }),
    providersFactories.metric && provideMetric({ useFactory: providersFactories.metric }),
    providersFactories.availableActions &&
      provideAvailableActions({ useFactory: providersFactories.availableActions }),
    providersFactories.visualizationData &&
      provideVisualizationData({ useFactory: providersFactories.visualizationData }),
    providersFactories.visualizationMeta &&
      provideVisualizationMeta({ useFactory: providersFactories.visualizationMeta }),
    providersFactories.baseComponent &&
      provideBaseComponent({ useFactory: providersFactories.baseComponent }),
  ].filter(x => x !== undefined);
